import { useMemo } from 'react';

function useGroupedDropdownOptions(groups, value, searchQuery, isFilterable) {
  const flatOptions = useMemo(
    () => groups.flatMap((g) => g.options.map((opt) => ({ ...opt, groupLabel: g.groupLabel }))),
    [groups],
  );

  const selectedOption = useMemo(() => flatOptions.find((op) => op.value === value), [value, flatOptions]);

  const filteredGroups = useMemo(() => {
    if (!isFilterable || !searchQuery.trim()) return groups;
    const q = searchQuery.toLowerCase();
    return groups
      .map((group) => ({
        ...group,
        options: group.options.filter((opt) => opt.label?.toLowerCase().includes(q)),
      }))
      .filter((group) => group.options.length > 0);
  }, [groups, searchQuery, isFilterable]);

  const flatFilteredOptions = useMemo(() => filteredGroups.flatMap((g) => g.options), [filteredGroups]);

  const hasOptions = flatFilteredOptions.length > 0;

  return {
    flatOptions,
    selectedOption,
    filteredGroups,
    flatFilteredOptions,
    hasOptions,
  };
}

export default useGroupedDropdownOptions;
